module.exports = __webpack_public_path__ + "static/media/posts-1.86fca948.jpg";